import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Spacings } from '@styles/index';
import P1 from '@base/P1/P1';
import H5 from '@base/H5/H5';
import Link from '@base/Link/Link';

const StyledUl = styled.ul`
  list-style: none;
  padding-left: 0px;
`;

const StyledLi = styled.li`
  margin-top: ${Spacings.SPACING_3B};
`;

const MenusNav = ({ data, currentHref }) => {
  return (
    <StyledUl>
      {data.map((dataItem, index) => {
        const { label, url } = dataItem;
        const isSelected = url.href === currentHref;
        return (
          <StyledLi key={String(index)}>
            <Link href={url.href} as={url.as}>
              {isSelected ? (
                <H5>{label}</H5>
              ) : (
                <P1 color="var(--color-text-secondary)">{label}</P1>
              )}
            </Link>
          </StyledLi>
        );
      })}
    </StyledUl>
  );
};

MenusNav.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  currentHref: PropTypes.string.isRequired
};

export default MenusNav;
